export const checkIsTableRowValid = (requiredConfig: string[], values: Record<string, any>) => {
    const emptyFields = requiredConfig.filter(
        (el) => values[el] !== false && values[el] !== 0 && values[el] !== '0' && !values[el],
    );
    return !emptyFields.length;
};
